export default {
  workshop: {
    breadcrumbHome: 'Home',
    breadcrumbSolutions: 'Solutions',
    breadcrumbCurrent: 'Workshop & trade',
    hero: {
      eyebrow: 'Workshop & trade',
      title: 'Robust security technology for tough operations',
      lead: 'Dust, moisture, temperature fluctuations – workshops place special demands. We mount cameras that keep up.',
    },
    areas: {
      title: 'Areas of use in workshops and trade',
      lead: 'From the workshop area to the outdoor yard – we secure your valuable tools, machines and vehicles.',
      items: {
        '0': { title: 'Workshop hall', desc: 'High halls with machines and workshops need robust cameras with good resolution – even in difficult light.' },
        '1': { title: 'Workshop area', desc: 'Tools, spare parts and ongoing jobs: surveillance protects your workspace and clarifies complaints.' },
        '2': { title: 'Loading zone', desc: 'Loading and unloading are windows for theft. Cameras at the loading zone reliably document every operation.' },
        '3': { title: 'Machine area', desc: 'Modern manufacturing requires complete process documentation – even across machines.' },
        '4': { title: 'Yard & parking', desc: 'Parked vehicles, trailers and materials – the yard needs weatherproof cameras with good night vision.' },
        '5': { title: 'Office & administration', desc: 'Quotes, invoices and customer data live in the office. Security must not be neglected here either.' },
      },
    },
    robust: {
      eyebrow: 'Robustness',
      title: 'Built for hard use',
      lead: 'Workshops and trade businesses are not showrooms. Our cameras are built for exactly such environments – and selected specifically for your conditions.',
      items: {
        '0': { title: 'High protection class', desc: 'IP66 housings protect against dust, splash water and rain – even in continuous outdoor use.' },
        '1': { title: 'Temperature & moisture resistant', desc: 'From an icy warehouse to a warm workshop: we choose cameras for the respective temperature range.' },
        '2': { title: 'Dust-protected housings', desc: 'In dusty environments, special housings and seals keep the optics clean and sharp for years.' },
      },
    },
    maintenance: {
      eyebrow: 'Maintenance & support',
      title: 'So your system stays reliable',
      lead: 'In dusty and rough environments, care determines the service life. With SSG Care your system stays ready at all times.',
      list: {
        '0': 'Regular checks by SSG Care – even outside the warranty',
        '1': 'Cleaning and visual inspection of housing and lens',
        '2': 'Firmware and security updates as needed',
        '3': 'Fast response to faults or failures',
        '4': 'Spare part and upgrade options for your system',
      },
      note: 'Note: The legal admissibility of video surveillance depends on the individual case. We advise you, but do not replace legal advice.',
    },
    cta: {
      title: 'Your workshop deserves the safe view',
      lead: 'We advise you, without obligation, which cameras your environment can withstand – and where they protect most.',
      primary: 'Arrange a consultation',
      secondary: 'Discover SSG Care',
    },
  },
};